<template>
  <div class="GlobalFooter">
    <div class="footerImg">
      <img
        @click="location(1)"
        src="../../public/img/productItem/zu.png"
        alt=""
      />
      <img
        @click="location(2)"
        src="../../public/img/productItem/facebook.png"
        alt=""
      />
      <img
        @click="location(3)"
        src="../../public/img/productItem/tuite.png"
        alt=""
      />
    </div>
    <div class="footerFlex">
      <div class="text1" @click="ToProtocol(1)">Privacy Policy</div>
      <div @click="ToProtocol(2)">Terms and Conditions</div>
    </div>
    <div class="footerFlex">
      Copyright 2021 Huaptec US INc. All Rights REserved.
    </div>
  </div>
</template>
<script>
import {httpUrl, baseUrl} from "../api/config";
export default {
  data() {
    return {};
  },
  methods: {
    location(num) {
      if (num == 1) {
        window.location.href =
          "https://www.youtube.com/channel/UCOzJ3MDYX3b5o9ENOo_BL1A";
      } else if (num == 2) {
        window.location.href = "https://www.facebook.com/hiboostusa/";
      } else if (num == 3) {
        window.location.href = "https://twitter.com/hiboost_usa";
      }
    },
    ToProtocol(num) {
      let src
      if (num == 1) {
        // src ='http://192.168.1.71:7115/protocol/privacyPolicy.html'
        src = httpUrl + 'protocol/privacyPolicy.html'
        window.open(src); 
      } else if (num == 2) {
        src = httpUrl + 'protocol/conditions.html'
        window.open(src); 
      } 
    }
  }
};
</script>
<style lang="less" scoped>
.GlobalFooter {
  background: #f6f8fa;
  height: 120px;
  display: flex;
  flex-flow: column;
  justify-content: space-around;
  padding: 0 10px;
  font-size: 10px;
  color: #090a0e;
  .footerImg {
    display: flex;
    justify-content: start;
    img {
      margin-right: 10px;
      width: 25px;
      height: 25px;
    }
  }
  .footerFlex {
    display: flex;
    text-align: left;
    .text1 {
      margin-right: 20px;
    }
  }
}
</style>
